import React, { useRef } from 'react';
import {
    TableBody,
    TableContainer,
    Table,
    LinearProgress,
} from '@mui/material';
import Card from '../../../../../muiComponents/Card';
import BookingTableRow from './BookingTableRow';
import useTranslate from '../../../../../customHooks/useTranslate';
import { useBookingList } from '../../../../contextsProperty/ContextBookings';
import TableHeader from '../../../../../Table/TableHeader';
import { bookingListColumns } from '../../../../../utils/bookings/bookingUtils';

const BookingsTable = () => {
    const { items, isLoading, handleScroll, sortDir, sortedBy, sortByField } =
        useBookingList();
    const translate = useTranslate();
    const tableContainer = useRef<HTMLDivElement | null>(null);

    return (
        <Card className={` flex-column flex-grow min-height-0 `}>
            <TableContainer
                ref={tableContainer}
                className=' flex-grow min-height-0 overflow-auto'
                onScroll={handleScroll}
            >
                <Table stickyHeader size='small'>
                    <TableHeader
                        headerColumns={bookingListColumns}
                        sortedBy={sortedBy}
                        sortDir={sortDir}
                        sortByField={sortByField}
                        isLoading={isLoading}
                        selectable={false}
                    />
                    <TableBody>
                        {items.map(item => {
                            return <BookingTableRow key={item.Id} row={item} />;
                        })}
                    </TableBody>
                    {(items.length === 0 || isLoading) && (
                        <caption className='no-results'>
                            {isLoading && <LinearProgress />}
                            {items.length === 0 &&
                                !isLoading &&
                                translate('no_results')}
                        </caption>
                    )}
                </Table>
            </TableContainer>
        </Card>
    );
};

export default BookingsTable;
